import cookieUtil from '@/common/cookieUtil'
import sysConfig from '@/../config/sysConfig'
import sessionUtil from '@/common/sessionUtil'
import store from "./../vuex/store"

export function getToken() {
    return cookieUtil.getCookie(sysConfig.cookieKeys.tokenKey)
}

export function getUserName() {
  return cookieUtil.getCookie(sysConfig.cookieKeys.tokenKey)
}

export function setToken(token) {
    cookieUtil.setCookie(sysConfig.cookieKeys.tokenKey, token, 0)
}

export function deleteToken() {
    cookieUtil.delCookie(sysConfig.cookieKeys.tokenKey)
}

// 获取用户类型
export function getJWT() {
    return sessionUtil.getSession(sysConfig.sessionStorageKeys.jwtToken)
}

export function setJWT(jwtToken) {
    sessionUtil.setSession(sysConfig.sessionStorageKeys.jwtToken, jwtToken)
}

export function deleteJWT() {
    sessionUtil.delSession(sysConfig.sessionStorageKeys.jwtToken)
}

export function getRefreshToken() {
    return cookieUtil.getCookie(sysConfig.cookieKeys.refreshKey)
}

export function setRefreshToken(token) {
    cookieUtil.setCookie(sysConfig.cookieKeys.refreshKey, token, 0)
}

export function deleteRefreshToken() {
    cookieUtil.delCookie(sysConfig.cookieKeys.refreshKey)
}
export function getExpireIn() {
    return cookieUtil.getCookie('expireIn')
}

export function setExpireIn(expireIn) {
    cookieUtil.setCookie('expireIn', expireIn, 0)
}

// 设置导航历史记录
export function deleteRecrdData() {
    sessionUtil.delSession('recrdData')
}
export function getRecrdData() {
    return sessionUtil.getSession('recrdData')
}

export function setRecrdData(recrdData) {
    sessionUtil.setSession('recrdData', recrdData, 0)
}





/**
 * 身份判断
 */
// 获取用户信息
const userTypeKey = sysConfig.userInfoKeys.userTypes

function checkUserType(userType) {
    // console.log('用户类型' + store.getters.userType)
    return store.getters.userType === userType
}
// 超级管理员
export function isSP_admin() {
    return checkUserType(userTypeKey.sp_admin)
}
// 管理员
export function isAdmin() {
    return checkUserType(userTypeKey.admin)
}
// 运营商
export function isOperator() {
    return checkUserType(userTypeKey.operator)
}
// 潜在运营商
export function isPot_operator() {
    return checkUserType(userTypeKey.pot_operator)
}
// 集团
export function isGroup() {
    return checkUserType(userTypeKey.group)
}
// 充电用户
export function isConsumer() {
    return checkUserType(userTypeKey.consumer)
}
// 场站人员
export function isStation() {
    return checkUserType(userTypeKey.station)
}


// WEBPACK FOOTER //
// ./src/common/oauth.js